const nibssBanks = [{
    cbn_code: "214",
    name: "First City Monument Bank Plc"
}, {
    cbn_code: "033",
    name: "UBA Plc"
}, {
    cbn_code: "058",
    name: "Guaranty Trust Bank Plc"
}, {
    cbn_code: "035",
    name: "Wema Bank Plc"
}, {
    cbn_code: "063",
    name: "Diamond Bank Plc"
}, {
    cbn_code: "057",
    name: "Zenith Bank Plc"
}, {
    cbn_code: "232",
    name: "Sterling Bank Plc"
}, {
    cbn_code: "044",
    name: "Access Bank Plc"
}, {
    cbn_code: "076",
    name: "Skye Bank Plc"
}, {
    cbn_code: "221",
    name: "Stanbic IBTC Bank Plc"
}, {
    cbn_code: "032",
    name: "Union Bank of Nigeria Plc"
}];

const coralPayBanks = [{
        cbn_code: "063",
        image_url: "https://cdn.onepipe.io/assets/jsui/clients/access-favicon-32x32.png",
        ussdString: "*901*",
        name: "ACCESS BANK"
    },
    {
        cbn_code: "050",
        image_url: "https://cdn.onepipe.io/assets/jsui/banks/ecobank-logo.svg",
        ussdString: "*326*",
        name: "ECOBANK"
    },
    {
        cbn_code: "070",
        image_url: "https://cdn.onepipe.io/assets/jsui/banks/fidelity-logo.svg",
        ussdString: "*770*",
        name: "FIDELITY BANK"
    },
    {
        cbn_code: "011",
        image_url: "https://cdn.onepipe.io/assets/jsui/banks/firstbank-logo.svg",
        ussdString: "*894*",
        name: "FIRST BANK"
    },
    {
        cbn_code: "214",
        image_url: "https://cdn.onepipe.io/assets/jsui/banks/fcmb-logo.svg",
        ussdString: "*329*",
        name: "FCMB"
    },
    {
        cbn_code: "058",
        image_url: "https://cdn.onepipe.io/assets/jsui/banks/gtb-logo.svg",
        ussdString: "*737*",
        name: "GTBANK"
    },
    {
        cbn_code: "030",
        image_url: "https://cdn.onepipe.io/assets/jsui/clients/heritage-favicon-32x32.png",
        ussdString: "*322*",
        name: "HERITAGE BANK"
    },
    {
        cbn_code: "301",
        image_url: "https://cdn.onepipe.io/assets/jsui/banks/jaiz-bank-logo.png",
        ussdString: "*389*",
        name: "JAIZ BANK"
    },
    {
        cbn_code: "082",
        image_url: "https://cdn.onepipe.io/assets/jsui/clients/keystone-favicon-32x32.png",
        ussdString: "*7111*",
        name: "KEYSTONE BANK"
    },
    {
        cbn_code: "076",
        image_url: "https://cdn.onepipe.io/assets/jsui/banks/polaris-logo.svg",
        ussdString: "*833*",
        name: "POLARIS BANK"
    },
    {
        cbn_code: "221",
        image_url: "https://cdn.onepipe.io/assets/jsui/banks/stanbicbank-logo.png",
        ussdString: "*909*",
        name: "STANBIC BANK"
    },
    {
        cbn_code: "232",
        image_url: "https://cdn.onepipe.io/assets/jsui/banks/sterling.jpg",
        ussdString: "*822*",
        name: "STERLING"
    },
    {
        cbn_code: "033",
        image_url: "https://cdn.onepipe.io/assets/jsui/clients/uba-favicon-32x32.png",
        ussdString: "*919*",
        name: "UBA"
    },
    {
        cbn_code: "032",
        image_url: "https://cdn.onepipe.io/assets/jsui/banks/union-logo.svg",
        ussdString: "*826*",
        name: "UNION BANK"
    },
    {
        cbn_code: "215",
        image_url: "https://cdn.onepipe.io/assets/jsui/banks/unity-bank-logo.png",
        ussdString: "*7799*",
        name: "UNITY BANK"
    },
    {
        cbn_code: "035",
        image_url: "https://cdn.onepipe.io/assets/jsui/banks/wema-bank.svg",
        ussdString: "*945*",
        name: "WEMA BANK"
    },
    {
        cbn_code: "057",
        image_url: "https://cdn.onepipe.io/assets/jsui/banks/zenith-logo.svg",
        ussdString: "*966*",
        name: "ZENITH"
    },
    {
        cbn_code: "566",
        image_url: "https://cdn.onepipe.io/assets/jsui/banks/vfd-logo.png",
        ussdString: "*5037*",
        name: "VFD MICROFINANCE BANK"
    },
];

export {
    nibssBanks,
    coralPayBanks
}